import { SVGProps } from "react";

export function InfoSolid(props: SVGProps<SVGSVGElement>) {
  const { fill, ...otherProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...otherProps}
    >
      <path
        d="M8.00065 11.3333C8.18954 11.3333 8.34787 11.2694 8.47565 11.1416C8.60343 11.0138 8.66732 10.8555 8.66732 10.6666C8.66732 10.4777 8.60343 10.3194 8.47565 10.1916C8.34787 10.0638 8.18954 9.99992 8.00065 9.99992C7.81176 9.99992 7.65343 10.0638 7.52565 10.1916C7.39787 10.3194 7.33398 10.4777 7.33398 10.6666C7.33398 10.8555 7.39787 11.0138 7.52565 11.1416C7.65343 11.2694 7.81176 11.3333 8.00065 11.3333ZM7.33398 8.66659H8.66732V4.66659H7.33398V8.66659ZM8.00065 14.6666C7.07843 14.6666 6.21176 14.4916 5.40065 14.1416C4.58954 13.7916 3.88398 13.3166 3.28398 12.7166C2.68398 12.1166 2.20898 11.411 1.85898 10.5999C1.50898 9.78881 1.33398 8.92214 1.33398 7.99992C1.33398 7.0777 1.50898 6.21103 1.85898 5.39992C2.20898 4.58881 2.68398 3.88325 3.28398 3.28325C3.88398 2.68325 4.58954 2.20825 5.40065 1.85825C6.21176 1.50825 7.07843 1.33325 8.00065 1.33325C8.92287 1.33325 9.78954 1.50825 10.6007 1.85825C11.4118 2.20825 12.1173 2.68325 12.7173 3.28325C13.3173 3.88325 13.7923 4.58881 14.1423 5.39992C14.4923 6.21103 14.6673 7.0777 14.6673 7.99992C14.6673 8.92214 14.4923 9.78881 14.1423 10.5999C13.7923 11.411 13.3173 12.1166 12.7173 12.7166C12.1173 13.3166 11.4118 13.7916 10.6007 14.1416C9.78954 14.4916 8.92287 14.6666 8.00065 14.6666Z"
        fill={fill || "#063982"}
      />
    </svg>
  );
}

